import { useEffect } from "react";
import { Anchor, Info } from "lucide-react";

const QA = [
  {
    q: "Le Bon Matelot, c'est quoi exactement ?",
    a: "Une plateforme de mise en relation entre passionnés de pêche en mer en Bretagne. Vous publiez ou rejoignez des sorties de pêche, vous partagez les frais.",
  },
  {
    q: "Comment payer ma participation ?",
    a: "Le paiement ne s'effectue jamais sur Le Bon Matelot. Les participants s'organisent directement avec le capitaine avant ou le jour de la sortie (espèces, virement, ou tout autre moyen convenu entre eux).",
  },
  {
    q: "Pourquoi parle-t-on de « participation aux frais » et non de « prix » ?",
    a: "Parce que ce n'est pas une activité commerciale. La participation couvre uniquement les frais réels de la sortie : carburant, appâts, consommables, entretien courant du matériel. Aucune marge, aucune commission.",
  },
  {
    q: "Y a-t-il une commission ?",
    a: "Non. Le Bon Matelot ne prélève aucune commission et n'intervient jamais dans la transaction.",
  },
  {
    q: "Que se passe-t-il si la sortie est annulée (météo, mer agitée…) ?",
    a: "Comme aucun paiement n'a été pris sur la plateforme, il n'y a rien à rembourser. Capitaine et participants se contactent directement pour reprogrammer.",
  },
  {
    q: "Quels types de pêche sont proposés ?",
    a: "Uniquement la pêche en mer entre passionnés : bar, lieu, maquereau, seiche, leurres, dérive, côtière, familiale. Aucune activité touristique.",
  },
];

export default function Faq() {
  useEffect(() => { document.title = "FAQ — Le Bon Matelot"; }, []);
  return (
    <div className="max-w-3xl mx-auto px-6 py-12">
      <div className="text-[11px] uppercase tracking-widest text-bretagne font-bold">Questions fréquentes</div>
      <h1 className="font-display text-3xl md:text-4xl font-bold text-ocean mt-1 tracking-tight">FAQ</h1>

      <div className="mt-6 bg-corail/10 border border-corail/30 rounded-2xl p-4 flex gap-3 text-sm text-ocean">
        <Info className="w-5 h-5 text-corail shrink-0 mt-0.5" />
        <div>
          <strong>Aucun paiement n'est réalisé sur Le Bon Matelot.</strong>{" "}
          La participation aux frais est indicative et se règle directement entre les membres.
        </div>
      </div>

      <div className="mt-8 divide-y divide-brume border-y border-brume">
        {QA.map((item, i) => (
          <details key={i} className="group py-4" data-testid={`faq-${i}`}>
            <summary className="flex justify-between items-center cursor-pointer list-none">
              <span className="font-display text-base md:text-lg font-bold text-ocean">{item.q}</span>
              <Anchor className="w-4 h-4 text-bretagne group-open:rotate-180 transition-transform" />
            </summary>
            <p className="mt-2 text-sm text-ocean/80 leading-relaxed">{item.a}</p>
          </details>
        ))}
      </div>
    </div>
  );
}
